// Auto-generated translation for pl.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:10:26.584535+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Dla właścicieli koni",
    title: "Wszystko dla Twojego konia. W jednej aplikacji.",
    subtitle: "Zarządzaj zdrowiem, treningiem, planowaniem i specjalistami z jednego przejrzystego profilu.",
    primaryCTA: {
      label: "Zacznij za darmo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil konia — waga, szczepienia, EquiCoach, żywienie i trening na jednym ekranie",
      caption: "Twój koń, w pełnym obrazie.",
    },
    problem: "Prawdopodobnie przechowujesz terminy, zdjęcia, treningi, żywienie i zdrowie w różnych miejscach — w grupach WhatsApp, pudełkach z dokumentami i osobnych aplikacjach. Przez to tracisz przejrzystość.",
    solution: "EquiSight tworzy z Twojego konia jeden kompletny cyfrowy profil, który zawsze masz przy sobie.",
    benefits: [
      "Jeden kompletny profil dla każdego konia",
      "Zdrowie, kowal, dentysta i fizjoterapeuta w jednym miejscu",
      "Kalendarz z inteligentnymi przypomnieniami",
      "Zdjęcia, notatki i historia bez limitu",
      "Kopia zapasowa wszystkich danych w Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 koń · zawsze za darmo",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Wiele koni + kopia zapasowa",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy na start?",
      title: "Zacznij dziś z pierwszym koniem.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Więcej koni. Większy przegląd. Większa pewność.",
    subtitle: "Przejdź na Premium i zarządzaj wszystkimi swoimi końmi bez ograniczeń — z pełną inteligencją EquiCoach.",
    primaryCTA: {
      label: "Zacznij 14 dni za darmo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Wszystkie ceny",
      href: "/#pricing",
    },
    audience: "Dla właścicieli, jeźdźców sportowych i hodowców koni posiadających wiele koni.",
    features: [
      "Dodawaj nieograniczoną liczbę koni",
      "Pełna historia każdego konia",
      "Kopia zapasowa danych",
      "Rozszerzone analizy EquiCoach",
      "Inteligentne powiadomienia i planowanie",
      "Zdrowie i trening w pełni połączone",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mniej niż €0,17 dziennie",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Przejdź na Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Dla jeźdźców w stajni",
    title: "Rozwijaj się, nawet bez własnego konia.",
    subtitle: "Śledź swoje lekcje, treningi i postępy w EquiSight — za mniej niż filiżanka kawy miesięcznie dla mamy lub taty. Albo pyszne lody z bitą śmietaną.",
    primaryCTA: {
      label: "Zacznij z Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Jak to działa?",
      href: "#features",
    },
    problem: "Jako jeździec w stajni często nie masz własnego konia, ale mimo to chcesz się rozwijać i mieć przegląd swoich lekcji, celów oraz koni, na których jeździsz.",
    solution: "Funkcjonalność stajni jest standardowo zawarta w planie Premium — śledź swój własny rozwój i przeglądaj przypisane konie stajenne w trybie tylko do odczytu.",
    features: [
      "Rejestrowanie treningów",
      "Wyznaczanie celów",
      "Śledzenie postępów",
      "Przeglądanie koni stajni z nazwą i zdjęciem",
      "Brak dostępu do prywatnych danych zdrowotnych",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Miesięcznie · funkcjonalność stajni w cenie",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Dołącz do nas",
      title: "Zacznij jako jeździec w stajni.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Dla ujeżdżalni i stajni",
    title: "Spraw, by Twoja ujeżdżalnia była cyfrowo dostępna dla każdego jeźdźca.",
    subtitle: "Daj jeźdźcom więź z końmi, lekcjami i postępami — bez udostępniania wrażliwych danych stajni.",
    primaryCTA: {
      label: "Poproś o dostęp",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz moduły",
      href: "#features",
    },
    audience: "EquiSight pomaga ujeżdżalniom i stajniom utrzymywać zaangażowanie jeźdźców przez dłuższy czas i wyróżniać się cyfrowo.",
    features: [
      "Udostępnianie koni ujeżdżalni jeźdźcom",
      "Imię i zdjęcie każdego konia",
      "Przypisywanie jeźdźców do koni",
      "Dostęp tylko do odczytu dla danych wrażliwych",
      "Scentralizowana historia lekcji i treningów",
      "Zarządzanie użytkownikami z rolami",
    ],
    benefits: [
      "Silniejsza więź z jeźdźcami",
      "Bardziej profesjonalny wizerunek",
      "Dodatkowa usługa cyfrowa dla członków",
      "Nowe źródło przychodów z korzystania z aplikacji",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Miesięcznie · funkcjonalność ujeżdżalni wliczona dla jeźdźców",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Aktywuj Moduł Ujeżdżalni.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Moduł hodowlany",
    title: "Kontrola nad cyklem, ciążą i rozwojem źrebięcia.",
    subtitle: "Kompletny moduł hodowlany dla właścicieli klaczy i hodowców — od krycia do źrebięcia, w jednej osi czasu.",
    primaryCTA: {
      label: "Aktywuj moduł hodowlany",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz funkcje",
      href: "#features",
    },
    audience: "Dla hodowców, właścicieli klaczy i stajni zarządzających wieloma klaczami.",
    features: [
      "Śledzenie cyklu",
      "Rejestrowanie rui",
      "Zapisywanie dat inseminacji",
      "Odliczanie do badań USG",
      "Planowanie kontroli ciąży",
      "Rodowód i pochodzenie",
      "Rozwój źrebięcia",
      "Przegląd wszystkich źrebnych klaczy",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Miesięcznie · Moduł hodowlany zawarty w planie Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Zacznij już dziś",
      title: "Rozpocznij zarządzanie hodowlą.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Moduł Kowal",
    title: "Pracuj mądrzej jako kowal. Dokumentuj wszystko profesjonalnie.",
    subtitle: "Kalendarz, zdjęcia, uwagi i historia zabiegów w jednym module — mniej nieporozumień, solidniejsza dokumentacja.",
    primaryCTA: {
      label: "Zacznij jako kowal",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz pakiet Professional",
      href: "/professional",
    },
    audience: "Dla kowali, którzy chcą poprawić organizację pracy, dokumentację i komunikację z klientami.",
    features: [
      "Własny kalendarz",
      "Wizyty według klienta",
      "Przeglądanie profili koni",
      "Dodawanie zdjęć przed i po zabiegu",
      "Notowanie przebiegu zabiegu",
      "Zapisywanie porad i uwag",
      "Powiadomienie ETA do klienta: \"Kowal jest w drodze\"",
    ],
    benefits: [
      "Bardziej profesjonalna praca",
      "Mniej nieporozumień",
      "Lepsza dokumentacja",
      "Silniejsza pozycja przy odpowiedzialności",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Miesięcznie · Moduł Kowal zawarty w pakiecie Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Aktywuj Moduł Kowal.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Moduł dentystyczny",
    title: "Kompletna dokumentacja stomatologiczna dla każdego konia.",
    subtitle: "Rejestruj wyniki, zabiegi i działania następcze bezpośrednio w EquiSight.",
    primaryCTA: {
      label: "Zacznij jako dentysta koni",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz pakiet Professional",
      href: "/professional",
    },
    audience: "Dentyści koni, lekarze weterynarii i gabinety, które chcą pracować w sposób uporządkowany.",
    features: [
      "Rejestrowanie kontroli uzębienia",
      "Wyniki według zabiegu",
      "Dodawanie zdjęć",
      "Raportowanie do właściciela",
      "Zalecenia następcze",
      "Historia każdego konia",
      "Planowanie nowej wizyty",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Miesięcznie · Moduł dentystyczny zawarty w planie Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Aktywuj moduł dentystyczny.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Moduł Fizjo / Osteo",
    title: "Profesjonalnie śledź ciało, ruch i regenerację.",
    subtitle: "Dla fizjoterapeutów i osteopatów, którzy chcą systematycznie opiekować się końmi.",
    primaryCTA: {
      label: "Rozpocznij jako fizjo/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz Pakiet Professional",
      href: "/professional",
    },
    features: [
      "Wywiad na konia",
      "Rejestrowanie wyników badania ciała",
      "Dodawanie zdjęć i filmów",
      "Tworzenie raportu z leczenia",
      "Udostępnianie ćwiczeń i dalszych kroków",
      "Śledzenie procesu regeneracji",
      "Historia na konia",
    ],
    benefits: [
      "Lepszy wgląd w czasie",
      "Profesjonalne raportowanie",
      "Przejrzysta komunikacja z właścicielem, trenerem i jeźdźcem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Miesięcznie · Moduł Fizjo / Osteo zawarty w pakiecie Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Aktywuj Moduł Fizjo / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Moduł trenera",
    title: "Trenuj jeźdźców z danymi, celami i postępami.",
    subtitle: "Spraw, by trening był mierzalny, a opieka bardziej profesjonalna — dla jednego lub wielu jeźdźców.",
    primaryCTA: {
      label: "Zacznij jako trener",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz pakiet Pro",
      href: "/#pricing",
    },
    audience: "Dla instruktorów, trenerów i coachów pracujących z wieloma jeźdźcami lub końmi.",
    features: [
      "Łączenie jeźdźców",
      "Śledzenie koni",
      "Ustawianie celów treningowych",
      "Dawanie informacji zwrotnej",
      "Analizowanie wyników zawodów",
      "Przeglądanie postępów każdej kombinacji",
      "Korzystanie z analiz protokołów dla skupienia treningowego",
    ],
    benefits: [
      "Lepsza opieka",
      "Więcej struktury",
      "Bardziej profesjonalna komunikacja",
      "Silniejsze relacje z klientami",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Miesięcznie · Moduł trenera zawarty w Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Aktywuj Moduł Trenera.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analiza zawodów",
    title: "Od protokołu do poprawy wyników.",
    subtitle: "Prześlij protokół z zawodów i odkryj, gdzie tracisz punkty — nie tylko sprawdzaj swój wynik, ale zrozum, jak możesz być lepszy.",
    primaryCTA: {
      label: "Analizuj swój pierwszy protokół",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz Premium",
      href: "/premium",
    },
    features: [
      "Przesyłanie zdjęcia protokołu",
      "Przetwarzanie przedniej i tylnej strony",
      "Rozpoznawanie klasy, numeru próby i sędziego",
      "Analiza wyników poszczególnych elementów",
      "Podsumowanie komentarzy",
      "Wyświetlanie mocnych i słabych stron",
      "Trendy dla kombinacji koń-jeździec",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Miesięcznie · analiza zawodów wliczona od planu Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Zacznij analizować zawody.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Pakiet Professional",
    title: "Dla profesjonalistów związanych z koniem.",
    subtitle: "Kowal, dentysta, fizjoterapeuta, osteopata czy trener: współpracujcie w jednej cyfrowej teczce konia.",
    primaryCTA: {
      label: "Zacznij jako profesjonalista",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zobacz poszczególne moduły",
      href: "#features",
    },
    audience: "Pakiet Professional łączy wszystkie moduły branżowe w jednej subskrypcji.",
    features: [
      "Moduł Kowala",
      "Moduł Dentysty",
      "Moduł Fizjo / Osteo",
      "Kalendarz i zarządzanie klientami",
      "Profile koni i raporty",
      "Historia leczenia i budowanie dokumentacji",
      "Komunikacja z właścicielem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Miesięcznie · wszystkie moduły branżowe w cenie",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gotowy?",
      title: "Wybierz Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Numery alarmowe dla konia",
    title: "Zawsze właściwa pomoc w zasięgu ręki.",
    subtitle: "W nagłym wypadku każda sekunda ma znaczenie. Dzięki EquiSight masz wszystkie ważne dane kontaktowe swojego konia zawsze pod ręką — jedno dotknięcie i dzwonisz.",
    primaryCTA: {
      label: "Przygotuj swoje kontakty alarmowe",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Zacznij bezpłatnie z EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Kontakty alarmowe — zadzwoń, wyślij WhatsApp lub nawiguj do weterynarza, kliniki i kowala jednym dotknięciem",
      caption: "Jedno dotknięcie. Żadnej paniki.",
      embeddedFrame: true,
    },
    problem: "Z twoim koniem coś się dzieje — kolka, uraz, panika. I zaczyna się szukanie. Kogo dzwonisz? Czy masz właściwy numer? Czy to numer alarmowy? Cenny czas zostaje stracony.",
    solution: "Dzięki EquiSight masz wszystko od razu pod ręką. Żadnego szukania. Żadnych wątpliwości. Jedno dotknięcie i masz kontakt.",
    scenario: {
      title: "Wyobraź sobie — Twój koń wykazuje objawy kolki.",
      steps: [
        "Otwierasz EquiSight",
        "Klikasz \"Weterynarz\"",
        "Dzwonisz od razu",
      ],
      tagline: "Żadnego stresu. Żadnego szukania. Tylko działanie.",
    },
    features: [
      "Wszystkie numery alarmowe w jednym miejscu",
      "Dzwonienie jednym dotknięciem z aplikacji",
      "WhatsApp jednym dotknięciem",
      "Bezpośrednia nawigacja do adresu",
      "Osobna lista kontaktów dla każdego konia",
      "Weterynarz, klinika, kowal, dentysta, fizjoterapeuta",
      "Adres i wskazówki dojazdu dostępne od razu",
      "Oznaczaj ulubione numery gwiazdką",
      "Numery alarmowe (112, 144) zawsze na górze",
    ],
    benefits: [
      "Spokój i kontrola w sytuacji awaryjnej",
      "Wszyscy w stajni mają te same numery pod ręką",
      "Koniec z zapomnianymi wizytówkami",
      "Reaguj kilka sekund szybciej w nagłych przypadkach",
    ],
    audience: "Dla właścicieli koni, opiekunów, trenerów i stajni — dla każdego, kto jest odpowiedzialny za konia.",
    showcase: {
      eyebrow: "Przygotowane zawczasu dla Ciebie",
      title: "13 kategorii kontaktów — gotowych do uzupełnienia.",
      description: "Od weterynarza i kliniki ratunkowej po siodlarza, instruktora i zarządcę pastwiska. EquiSight zna Twój świat i przygotowuje dla Ciebie odpowiednie pola kontaktowe. Dotknij, wypełnij, gotowe.",
      bullets: [
        "Nagłe przypadki i zdrowie — weterynarz, pogotowie, klinika, linia zatruć",
        "Codzienna opieka — kowal, dentysta, fizjoterapeuta, instruktor",
        "Stajnia i pastwisko — właściciel stajni, zarządca pastwiska, pensjonat",
        "Pasza i materiały — dostawcy siana, paszy treściwej, słomy",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Ekran zarządzania kontaktami alarmowymi — wszystkie sugerowane kontakty według kategorii",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Lista kontrolna numerów alarmowych dla konia",
      items: [
        "Weterynarz",
        "Klinika ratunkowa (24/7)",
        "Pogotowie dla zwierząt · 144",
        "Kowal",
        "Zastępczy kontakt awaryjny",
        "Ogólny numer alarmowy · 112",
      ],
      cta: {
        label: "Otwórz w EquiSight i wypełnij od razu",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Numery alarmowe",
          price: "Gratis",
          note: "Zawsze bezpłatnie · dla każdego, w każdym abonamencie",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Zadbaj o to, żeby być przygotowanym",
      title: "Zanim będzie to potrzebne.",
      href: "/#waitlist",
    },
    microcopy: [
      "Żadnych zobowiązań",
      "Konfiguracja w 2 minuty",
      "Zawsze możliwe do edycji",
    ],
  },
};

export default LANDINGS;
